var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineTree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A38D7CF1-C431-4237-B345-343659943DD5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional",
    transform: "translate(-108.000000, -636.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "tree",
    transform: "translate(108.000000, 636.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.83022463,10.809844 C6.97022462,10.809844 6.31024781,10.4698458 6.0102478,9.88984585 C5.71024778,9.29984587 5.8302246,8.56984323 6.3302246,7.87984324 L10.5002379,2.03984708 C11.240238,0.979847133 12.770227,0.97984916 13.520227,2.04984921 L17.6902409,7.87984324 C18.1902409,8.56984323 18.3102482,9.29984587 18.0102482,9.88984585 C17.6902482,10.4698458 17.0302519,10.809844 16.1702518,10.809844 L7.83022463,10.809844 Z M11.7202392,2.89984775 L7.55022585,8.74984598 C7.35022585,9.01984599 7.34024416,9.17984507 7.35024416,9.20984507 C7.36024416,9.22984507 7.5002344,9.30984402 7.8402344,9.30984402 L16.1802311,9.30984402 C16.5102311,9.30984402 16.6502518,9.21984293 16.6702518,9.19984293 C16.6702518,9.17984293 16.6602396,9.01984599 16.4702396,8.74984598 L12.3002257,2.90984988 C12.1902257,2.76984988 12.0902379,2.69984317 12.0002379,2.69984317 C11.9102379,2.69984317 11.8102392,2.77984775 11.7202392,2.89984775 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.41967845,18.750061 C4.9896785,18.750061 4.41965637,18.0600626 4.20965637,17.6500626 C3.99965638,17.2400626 3.77966005,16.3800622 4.61966002,15.2200623 L8.60965014,9.62006378 C8.74965014,9.42006378 8.97966601,9.31005859 9.219666,9.31005859 L14.7896738,9.31005859 C15.0296738,9.31005859 15.2596592,9.43006378 15.3996592,9.62006378 L19.3896799,15.2300644 C20.2296799,16.3800644 19.9996738,17.2400626 19.7896738,17.6500626 C19.5796738,18.0600626 19.0196615,18.750061 17.5896616,18.750061 L6.41967845,18.750061 Z M5.82965147,16.1000595 C5.50965148,16.5400595 5.47967345,16.8400623 5.53967345,16.9700623 C5.60967345,17.1000623 5.86966866,17.250061 6.40966868,17.250061 L17.5796518,17.250061 C18.1196519,17.250061 18.3896775,17.1000623 18.4496775,16.9700623 C18.5196775,16.8400623 18.4796689,16.5400595 18.1596689,16.1000595 L14.3896799,10.8000641 L9.59967089,10.8000641 L9.59967089,10.8100586 L5.82965147,16.1000595 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25,22 L11.25,18 C11.25,17.59 11.59,17.25 12,17.25 C12.41,17.25 12.75,17.59 12.75,18 L12.75,22 C12.75,22.41 12.41,22.75 12,22.75 C11.59,22.75 11.25,22.41 11.25,22 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTree);
export default __webpack_public_path__ + "static/media/vuesax-outline-tree.451c11d9719862051cdfcd6f6c81b178.svg";
export { ForwardRef as ReactComponent };